import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import AddArea from '../admin/AddArea';
import '../../assests/css/common/responsive-ui.css';
import UserAddressService from '../../services/useraddress/useraddress.service';
import { PincodeAreaModel } from '../../models/cust-address/cust-address-model';
 
interface SearchPanelProps {
  reloadPage: (value: boolean) => void;
  setLoading: (loading: boolean) => void;
  setPageNumber: (pageNumber: number) => void;
  setPageSize: (pageSize: number) => void;
  setAreaList: (areas: PincodeAreaModel[]) => void;
  setTotalRecords: (total: number) => void;
  setFilter: (filter: any) => void;
  setSearchTerm: (searchTerm: any) => void;
}
 
const AreaSearch: React.FC<SearchPanelProps> = ({
  reloadPage,
  setLoading,
  setPageNumber,
  setPageSize,
  setAreaList,
  setTotalRecords,
  setFilter,
  setSearchTerm
}) => {
  const { t } = useTranslation();
  const [selectedColumn, setSelectedColumn] = useState<string>('');  
  const [searchText, setSearchText] = useState<string>('');  
  const [isAddArea, setAddArea] = useState(false);
 
  const columnOptions = [
    { label: 'Select Region', value: '' },
    { label: 'Pincode', value: 'pincode' },
    { label: 'Area', value: 'area' },
    { label: 'Sub District', value: 'subdistrict' },
    { label: 'District', value: 'district' },
    { label: 'State', value: 'state' },
    { label: 'Country', value: 'country' },
  ];
 
  const handleColumnChange = (e: DropdownChangeEvent) => {
    const selectedValue = e.value;
    setSelectedColumn(selectedValue);
    setPageNumber(1);
    setPageSize(10);
    fetchData(selectedValue, searchText, 1, 10);
  };
 
  const handleSearch = () => {
    setPageNumber(1);
    setPageSize(10);
    fetchData(selectedColumn, searchText, 1, 10);
  };
 
  const fetchData = async (filterBy: any, searchTerm: any, pageNumber: number, pageSize: number) => {
    setLoading(true);
    try {
      const response = await UserAddressService.searchFilterPincode(filterBy, searchTerm, pageNumber, pageSize);
      if (response) {
        setAreaList(response.areas);
        setTotalRecords(response.totalRecords);
        setFilter(filterBy);
        setSearchTerm(searchTerm);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAreaList([]);
    } finally {
      setLoading(false);
    }
  };
 
  const resetSearchFields = () => {
    setSearchText('');
    setSelectedColumn('');
    fetchData('', '', 1, 10);
  };
 
  const hideAddAreaModal = () => {
    setAddArea(!isAddArea);
    reloadPage(!isAddArea);
  };
 
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchText.trim().length > 1) {
        setPageNumber(1);
        setPageSize(10);
        fetchData(selectedColumn, searchText, 1, 10);
      } else if (searchText.trim().length === 0) {
        fetchData('', '', 1, 10);
      }
    }, 500);
 
    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);
 
  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: "left", width: "18%" }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              placeholder="Keyword Search"
              style={{ width: "100%" }}
            />
          </div>
        </div>
 
        <div className="dropdown-search font-bold text-white border-round" style={{ float: "left", width: "20%" }}>
          <Dropdown
            value={selectedColumn}
            options={columnOptions}
            onChange={handleColumnChange}
            placeholder="Select Region"
            style={{ width: "100%" }}
          />
        </div>
 
        <div className="buttons-container">
          {/* <div className="filter-button font-bold text-white border-round" style={{ float: "left", textAlign: 'right', width: "10%" }}>
            <Button
              className="text-black border-round"
              style={{ width: "100%", textAlign: 'center' }}
              onClick={handleSearch}
              severity="success"
            >
              Filter
            </Button>
          </div> */}
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: "left", textAlign: 'right', width: "10%" }}>
            <Button
              className="text-black border-round"
              style={{ width: "100%", textAlign: 'center' }}
              onClick={resetSearchFields}
              severity="success"
              raised
            >
              Reset
            </Button>
          </div>
          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-green-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setAddArea(!isAddArea)}
              severity="secondary"
              text
              raised
            >
              Add
            </Button>
          </div>
        </div>
        {isAddArea && <AddArea showAddUserModal={isAddArea} hideAddUserModal={hideAddAreaModal} />}
      </div>
    </div>
  );
};
 
export default AreaSearch;
 
 